import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Dispatch } from '@app/store/types';

import { checkContractLinkLimits } from '../../actions';
import { MaxActiveLinksError } from '../../convertToContractLinkErrors';

export default function useStartContractLink() {
  const dispatch = useDispatch<Dispatch>();
  const [isLoading, setIsLoading] = useState(false);

  const startContractLink = useCallback(async () => {
    setIsLoading(true);
    try {
      const checkLimitResultAction = await dispatch(checkContractLinkLimits());

      if (checkContractLinkLimits.fulfilled.match(checkLimitResultAction)) {
        const { payload } = checkLimitResultAction;
        if (payload.isLimitExceeded) {
          /**
           * TODO: @Juyeong-Byeon 이슈 논의 후 처리
           * 비즈니스 규칙에 따른 분기를 try catch로 처리하는 부분에 대하여
           * https://github.com/modusign/modusign-client/issues/9103
           *
           */
          throw new MaxActiveLinksError(
            payload.concurrentActiveLinksLimit,
            payload.activeLinkCount
          );
        }
      }

      if (checkContractLinkLimits.rejected.match(checkLimitResultAction)) {
        throw new Error(checkLimitResultAction.error.message);
      }
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

  return { isLoading, startContractLink };
}
